<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-button type="primary" @click="onsubmit">保 存</a-button>
      <div class="content">
        <div class="list_text selectType" style="margin-top: 20px;">
          <div class="label_text">系统名称：</div>
          <a-input placeholder="请输入系统名称" v-model="form.name" style="width: 400px;"/>
        </div>

        <div class="list_text selectType" style="margin-top: 20px;">
          <div class="label_text">系统Logo：</div>
          <a-input disabled v-model="form.logo[0]" style="width: 400px;"/>

         <OssUploadMulti v-model="form.logo" @cancelImg="cancelImg" :isArrayData="true" templateName='button' :maxCount="1" 
          type="img"></OssUploadMulti>
          
        </div>
        <div style="width:80px;height:82px;margin-top: 20px;" v-if="form.logo.length>0">
              <img  :src="form.logo[0]" style="width:100%;height:100%; margin-left:150px"
                  v-image-preview alt="none"/>
            </div>

        <div class="list_text selectType" style="margin-top: 20px;">
          <div class="label_text">系统背景：</div>
          
          <a-input disabled v-model="form.backgroundImg[0]" style="width: 400px;"/>

         <OssUploadMulti v-model="form.backgroundImg" @cancelImg="cancelbImg" :isArrayData="true" templateName='button' :maxCount="1" type="img"></OssUploadMulti>
            
          
        </div>
        <div style="width:80px;height:82px;margin-top: 20px;" v-if="form.backgroundImg.length>0">
              <img  :src="form.backgroundImg[0]" style="width:100%;height:100%;margin-left:150px"
                  v-image-preview alt="none"/>
            </div>





       
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { diyPageEdit, diyPageAdd,diyPageList } from '@/api/system/basic'

import OssUploadMulti from "@/components/OssUploadMulti";
export default {
    components: { OssUploadMulti },
  data() {
    return {
        detailId:'',
        typeName:'add',
        form:{
          id:' ',
            name:'',
            logo:[],
            backgroundImg:[]
        }
    }
  },
  created() {
    
  },
  computed: {},
  watch: {},
  mounted() {
    this.diyPageEdit()
    
  },
  methods: {
    diyPageEdit(){
      this.form.logo = []
      this.form.backgroundImg = []

      diyPageList().then(res=>{
        console.log(res,'pppppp');
        if(res.code=='20001'){
          if(res.data.length==0){
            this.typeName = 'add'
          }else{
    
            this.detail = res.data[0]
            this.$set(this.form, 'id', res.data[0].id)
            this.$set(this.form, 'name', res.data[0].pageName)

          
            this.form.logo.push(res.data[0].indexPage)
            this.form.backgroundImg.push(res.data[0].pageData)
            this.typeName = 'edit'
          }

        }
      })
    },
    cancelImg(){
      this.form.logo = ''
    },
    cancelbImg(){
      this.form.backgroundImg = ''
    },


    onsubmit(){
      let list = {
   
        "projectId": 1,
        "pageName": this.form.name,
        "indexPage": this.form.logo.length > 0 ? this.form.logo[0]: '',
        "pageData": this.form.backgroundImg.length > 0 ? this.form.backgroundImg[0]: '',
        "isIndex": false
      }
      console.log(list,'formList');
      if(!this.form.name){
        this.$message.error('请输入系统名称！')
        return false;
      }

      if(this.form.logo.length==0){
        this.$message.error('请选择系统Logo！')
        return false;
      }

       if(this.form.backgroundImg.length==0){
        this.$message.error('请选择系统背景！')
        return false;
      }
      

      
      
      // if(this.form.logo){
      //   list.push({
      //     projectId:1,
      //     pageName:'头像',
      //     pageData:this.form.logo[0],
      //     isIndex:false
      //   })
      // }
      // if(this.form.backgroundImg){
      //   list.push({
      //     projectId:2,
      //     pageName:'背景',
      //     pageData:this.form.backgroundImg[0],
      //     isIndex:false
      //   })
      // }
      //  if(this.form.name){
      //   list.push({
      //     projectId:3,
      //     pageName:this.form.name,
      //     pageData:'',
      //     isIndex:false
      //   })
      // }

      if(this.typeName=='add'){
        diyPageAdd(list).then(res=>{ 
          console.log(res);
          if(res){
            this.$message.success('添加成功')
            this.diyPageEdit()
          }
          
        })
      }else{
        let params = {
        "id": this.form.id,
        "projectId": 1,
        "pageName": this.form.name,
        "indexPage": this.form.logo.length > 0 ? this.form.logo[0] : '',
        "pageData": this.form.backgroundImg.length > 0 ? this.form.backgroundImg[0]: '',
        "isIndex": false
      }
      console.log(params);
      

        diyPageEdit(params).then(res=>{ 
          console.log(res);
          if(res){
            this.$message.success('修改成功')
            this.diyPageEdit()
          }
          
        })

      }
      console.log(12121212);
      
    }




  }
}
</script>

<style scoped>
.content{
  margin-top: 20px;
  margin-left: 20px;
  height: 70vh;
}
.list_text{
    display: flex;
}

.label_text{
  width: 150px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
}
.onimg{
    margin-left: 10px;
    width: 100px;
    height: 100px;
    background: #ccc;
    border-radius: 10px;
    overflow: hidden;
}

.selectType{
  display: flex;
  align-items: center;
}
.tempBox{
  margin-top: 15px;
}
</style>
